<template>
    <BlockWrapper
        v-for="block in pageBlocks"
        :key="block.canonicalUid"
        :block="block"
    />
</template>

<script setup>
    import BlockWrapper from '~/components/blocks/BlockWrapper.vue'

    const { query } = useGraphQL()
    const { entry } = storeToRefs(useEntryStore())

    const { contentBuilderKeys, queryContentBuilder } = useContentBuilder()

    const contentQuery = await queryContentBuilder(entry.value)

    const contentBuilderKey = computed(() => {
        return contentBuilderKeys[entry.value?.__typename] ?? 'contentBuilder'
    })

    const queryData = async () => {
        if (!contentQuery) {
            return
        }

        // check if this entry already has data
        if (entry.value?.fetched) {
            return
        }

        const contentData = await query({
            query: contentQuery,
            variables: {
                canonicalUid: entry.value?.canonicalUid
            },
            key: `${entry.value?.uri}-content`,
        })

        // merge entry data with content data
        entry.value = merge({}, entry.value, {
            fetched: true,
            ...contentData?.entry
        })

    }

    await queryData()

    const pageBlocks = computed(() => {
        return get(entry.value, contentBuilderKey.value, [])
    })

</script>
